import type { QueryKey } from "@tanstack/react-query"

const EQueryKey: (params: { participantId: number }) => QueryKey = (params: { participantId: number }): QueryKey => [
    "DiagnosticSummary",
    `participantId:${params.participantId}`
]

const EQueryUrl: (params: { participantId: number }) => string = (params: { participantId: number }): string =>
    `/api/participant/${params.participantId}/diagnostic-summary/`

export { EQueryKey as EDiagnosticSummaryQueryKey, EQueryUrl as EDiagnosticSummaryQueryUrl }
